export const MaxResolutions = {
    Mobile: 768
};

export default class Screen {
    static get isMobile() {
        return window.screen.availWidth <= MaxResolutions.Mobile;
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Helpers/Screen.js